import type { PropsWithChildren } from 'react';
import type React from 'react';

import {
	PetitionDetailsPageDataContextProvider,
	PetitionDetailsPageUserDataContextProvider,
} from '#src/app/pages/petitionDetails/pageContext';
import { PetitionStatsStateProvider } from '#src/app/pages/petitionDetails/shared/hooks';

import type { MobileModalContext } from './types';

export const MobileModalContextDecorator: React.FC<PropsWithChildren<MobileModalContext>> = ({
	stats,
	pageData,
	pageUserData,
	children,
}) => {
	return (
		<PetitionStatsStateProvider value={stats}>
			<PetitionDetailsPageDataContextProvider pageData={pageData}>
				<PetitionDetailsPageUserDataContextProvider pageUserData={pageUserData}>
					{children}
				</PetitionDetailsPageUserDataContextProvider>
			</PetitionDetailsPageDataContextProvider>
		</PetitionStatsStateProvider>
	);
};
